import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
//@ts-expect-error untyped
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { createGetWhatsAppSubscriptions, getWhatsAppSubscriptions } from '../api/CommunicationSubscriptionAPI';
export const createWhatsAppSubscriptionReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.WHATSAPP_SUBSCRIPTIONS,
  createFetchData: createGetWhatsAppSubscriptions,
  fetchData: getWhatsAppSubscriptions
}, options));
export default createWhatsAppSubscriptionReferenceResolver();